import React from 'react';
import ReportDaily from '../../../../../components/pages/reportDaily';
import { useFetch } from '../../../../../hooks/useFetch';

export default () => {
    return (
        <ReportDaily
            title={'Import Airwaybill'}
            repType={'airwaybill'}
            url={"/api/v1/report_import_pjt"}
            FetchComponent={useFetch}
        />
    )
}